import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeaturedBlogs from "./FeaturedBlogs";
import { getAllBlogs } from "../../lib/firebase/blogs";
import { Dropdown, Spin } from "antd";
import { categorys } from "../../lib/categorys";
import { ChevronDown } from "lucide-react";

export const allowedEmails = [
  "hazrataliein@gmail.com",
  "programmer.hazratali@gmail.com",
  "iushazratali@gmail.com",
  "hazratalisoft@gmail.com",
];

const AllBlog = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 9;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const categoryRaw = queryParams.get("category") || "";
  const search = decodeURIComponent(categoryRaw)

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getAllBlogs();
        setBlogs(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching blogs:", error);
      }
    })();
  }, []);

  useEffect(() => {
    if (!blogs.length) return;
    console.log(search);
    if (!search || search === "all") {
      setFilteredBlogs(blogs);
      setActiveCategory("all");
    } else {
      const matched = blogs.filter(
        (b) => b.category === search
      );
      setFilteredBlogs(matched);
      setActiveCategory(search);
    }

    setCurrentPage(1);
  }, [search, blogs]);

  const handleCategoryClick = (category) => {
    const cleanCategory = category.trim().toLowerCase();
    navigate(`/all-blog?category=${encodeURIComponent(cleanCategory)}`);
  };

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const matchedCategory = categorys.find(
    (category) => category.name === search
  );

  const matchedSubCategory =
    categorys
      .find((category) => category.subcategories)
      ?.subcategories?.find(
        (sub) => sub.name === search
      );

  const resultName =
    matchedCategory?.name || matchedSubCategory?.name || "All Blogs";

  if (loading) {
    return (
      <div className="min-h-screen">
        <Spin size="large" fullscreen />
      </div>
    );
  }

  return (
    <section className="max-w-7xl mx-auto py-10 text-white min-h-screen">
      {!search || search === "all" ? (
        <>
          <FeaturedBlogs blogs={blogs} />
          <div className="flex justify-center mb-6 space-x-4 flex-wrap space-y-3">
            {categorys.map((category) => {
              if (category.subcategories) {
                return (
                  <Dropdown
                    key={category.id}
                    menu={{
                      items: category.subcategories.map((sub) => ({
                        label: (
                          <button>{sub.name}</button>
                        ),
                        key: sub.name,
                        onClick: () => handleCategoryClick(sub.name),
                      })),
                    }}
                  >
                    <button
                      className={`px-4 py-2 rounded-lg ${activeCategory === category.name.toLowerCase()
                        ? "bg-indigo-600"
                        : "bg-gray-800"
                        } hover:bg-indigo-500 flex items-center`}
                    >
                      {category.name} <ChevronDown />
                    </button>
                  </Dropdown>
                );
              } else {
                return (
                  <button
                    key={category.id}
                    onClick={() => handleCategoryClick(category.name)}
                    className={`px-4 py-2 rounded-lg ${activeCategory === category.name.toLowerCase()
                      ? "bg-indigo-600"
                      : "bg-gray-800"
                      } hover:bg-indigo-500`}
                  >
                    {category.name}
                  </button>
                );
              }
            })}
          </div>
        </>
      ) : null}

      <motion.h2 className="text-4xl text-center font-bold mb-10 capitalize">
        {search && search !== "all" ? resultName : (
          <>All <span className="text-indigo-500">Blogs</span></>
        )}
      </motion.h2>

      {currentBlogs.length === 0 ? (
        <h1 className="text-3xl text-center font-bold mb-10">No Blogs Found</h1>
      ) : null}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {currentBlogs.map((blog) => (
          <div key={blog.id} className="relative rounded-lg overflow-hidden group">
            <Link to={`/blog/${blog.id}`}>
              <img
                src={blog.coverImage}
                alt="blog"
                className="w-full h-72 object-cover transition duration-300 ease-in-out group-hover:opacity-60"
              />
              <div className="absolute inset-0 bg-indigo-900 bg-opacity-50 flex items-center justify-center transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out">
                <h3 className="text-white text-2xl font-semibold text-center px-4">
                  {blog.title}
                </h3>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-10 space-x-2">
        {Array.from({
          length: Math.ceil(filteredBlogs.length / blogsPerPage),
        }).map((_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`px-3 py-2 rounded-md ${currentPage === index + 1
              ? "bg-indigo-600"
              : "bg-gray-800"
              } hover:bg-indigo-500`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </section>
  );
};

export default AllBlog;